import styled from "styled-components";
import { H3 } from "../../../../common";

export const CurrentPageText = styled(H3)`
  color: white;
`;
